import React from 'react'
import OverviewTable from './OverviewTable'

export default function ProductOverviewTable() {
  return <OverviewTable module="PRODUCT" redirect="product" />
}
